import { UseTranslationResponse } from 'react-i18next';

export default function getFirstExistingTranslation(
  t: UseTranslationResponse<'translation', undefined>['t'],
  i18n: UseTranslationResponse<'translation', undefined>['i18n'],
  keys: string[]
) {
  const existingKey = keys.find((key) => i18n.exists(key));
  if (existingKey) {
    return t(existingKey);
  }
  return keys[keys.length - 1];
}
